export const environment = {
  name: 'production',
  production: true,
  apiConfiguration: {
    basePath: '/links/tickets-passes/api',
    paths: {
      config: '/config',
      validate: '/validate',
      link: '/link',
      translate: '/translate',
      dirtyWords: '/validate/dirty-words/',
      pageKeyData: '/page-key-data'
    }
  }
};
